import { isEmpty } from "lodash-es";
import { useHideEmailForm } from "../hooks/useHideEmailForm";
import type { NewsletterPolicy } from "../types";
import { useLocale } from "next-intl";
import { usePathname } from "next/navigation";

type Config = {
    newsletterPolicy?: NewsletterPolicy;
};

export const useShowFooter = ({ newsletterPolicy }: Config) => {
    const locale = useLocale();
    const pathname = usePathname().toString();

    const hideForm = useHideEmailForm({ locale, pathname });

    const isEmptyData =
        !newsletterPolicy || isEmpty(Object.values(newsletterPolicy).filter(Boolean));

    return {
        shouldHideFooter: hideForm || isEmptyData,
    };
};
